import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { ErrorVariants, Toast, ToastType } from './model';

export const TOAST_FEATURE_KEY = 'toast';

export const initialToastState: Toast = {
  canDisplay: false,
  message: '',
  responseStatus: '',
  type: ErrorVariants.SUCCESS,
  position: 'right',
  toast: true,
  msg: '',
  toastType: ToastType.ERROR,
  title: '',
};

export const toastSlice = createSlice({
  name: TOAST_FEATURE_KEY,
  initialState: initialToastState,
  reducers: {
    showToast(state, action: PayloadAction<Toast>) {
      state.canDisplay = true;
      state.message = action.payload.message;
      state.responseStatus = action.payload.responseStatus;
      state.type = action.payload.type;
    },
    hideToast(state) {
      state.canDisplay = false;
      state.message = '';
      state.responseStatus = '';
    },
    updateToast(state, action: PayloadAction<Toast>) {
      state.toast = action.payload.toast;
      state.msg = action.payload.msg;
      state.title = action.payload.title;
      state.toastType = action.payload.toastType;
    },
  },
});

export const toastReducer = toastSlice.reducer;

export const { showToast, hideToast, updateToast } = toastSlice.actions;

export const getToastState = (rootState: RootState): Toast =>
  rootState[TOAST_FEATURE_KEY];

export const getToastVisibility = createSelector(
  getToastState,
  (state) => state.canDisplay
);

export const getToast = createSelector(getToastState, (state) => ({
  ...state,
}));

export const getUpdatedToast = createSelector(getToastState, (state) => state);
